import React from 'react';

import { Container } from './styles';

const RowGroup: React.FC = ({ children }) => {
  return <Container>{children}</Container>;
};

export default RowGroup;
